module.exports = __webpack_public_path__ + "media/diverticulosis.229c55a3.wav";